/*/
 * Alert
 *
 * Text: string
 * Class: alert--i_success | alert--i_error
 * Seconds: time visible in ms
 *
/*/
	window.siteAlert = function (params) {
		params = {
			text: params.text ? params.text : '',
			class: params.class ? params.class : 'alert--i_success',
			seconds: params.seconds ? params.seconds : 6000,
		}

		const alert = document.createElement('div')
		alert.classList.add('alert--i', params.class)
		alert.innerHTML = params.text

		document.querySelector('#app').appendChild(alert);

		setTimeout(function () { alert.classList.add('is--visible') }, 500)
		setTimeout(function () { alert.classList.remove('is--visible') }, params.seconds)
		setTimeout(function () { alert.remove() }, params.seconds + 500)

		alert.addEventListener('click', function () {
			this.classList.remove('is--visible')
			setTimeout(function () { alert.remove() }, 500)
		})
	}
